import { render, staticRenderFns } from "./Step5Overview.vue?vue&type=template&id=a1ab2c5a"
import script from "./Step5Overview.vue?vue&type=script&lang=js"
export * from "./Step5Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports